<template>
  <div>
    <section class="section-title-page container-fluid" style="background-image: url('resources/img/example.jpg')">
      <div class="container">
        <div class="wrapper">
          <h1>Bolsa <small style="font-weight: 300"> de Trabajo</small></h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/Servicios/">Servicios</a>
          </span>
        </div>
      </div>
    </section>

    <section class="section-page container-fluid">
      <div class="container">
        <div class="section-info">
          <p class="m-0">
            <i class="fa-solid fa-circle mr-2"></i>Explora
            <strong>ofertas laborales</strong> exclusivas para profesionales del
            sector veterinario y encuentra oportunidades adecuadas a tu perfil.
          </p>
        </div>
      </div>
      <div class="container service-selected-search">
        <div class="col rounded p-3 bg-white">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead class="bg-black text-white">
                <tr>
                  <th>N°</th>
                  <th class="text-center">Institución/Empresa</th>
                  <th class="text-center">Fecha Inicio</th>
                  <th class="text-center">Fecha Fin</th>
                  <th class="text-center">Web</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in ListaConvocatorias" :key="key" class="">
                  <td>{{ key + 1 }}</td>
                  <td class="text-center">{{ value.institucion }}</td>
                  <td class="text-center">{{ value.inicio }}</td>
                  <td class="text-center">{{ value.fin }}</td>
                  <td class="text-center">
                    <a :href="value.pagina_web" target="_blank">
                      <i class="fas fa-link text-white bg-brown rounded p-2"></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="ListaConvocatorias.length < 1">
                  <td colspan="5" class="text-center">
                    <i>No hay resultados</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "bolsa_trabajo",
  computed: {
    ...mapState(["empresa"]),
  },
  created() { },
  mounted() {
    this.getConvocatorias();
  },
  data() {
    return {
      ListaConvocatorias: [],
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getConvocatorias() {
      this.setLoading(true);
      this.$http.get("ws_jobs/job_call").then((res) => {
        this.ListaConvocatorias = res.data.Convocatorias;
        this.setLoading(false);
      });
    },
  },
};
</script>